import React from "react";
import { useLocation, Link } from "react-router-dom";
// import { Modal, Button, Alert } from "react-bootstrap";

// const CookiePolicy = "/documents/Vesseli_International_Ltd_-_cookie_policy.docx";
// const TermsConditions = "/documents/Vesseli_International_Ltd_sign-up_Ts_and_Cs.docx";
// const PrivacyPolicy = "/documents/Privacy policy - Vesseli International Ltd.docx";
// const ChildPolicy = "/documents/Vesseli Child Protection Policy.docx";

// const LazyFileViewer = React.lazy(() => import("react-file-viewer"));

const Footer = () => {
  const location = useLocation();
  // const [showModal, setShowModal] = useState(false);
  // const [activeDocument, setActiveDocument] = useState(null);
  // const [documentTitle, setDocumentTitle] = useState("");
  // const [viewerError, setViewerError] = useState(false);
  // const [useFallback, setUseFallback] = useState(false);
  // const [modalHeight, setModalHeight] = useState(450);
  // useEffect(() => {
  //   // Adjust viewer height based on window size
  //   const handleResize = () => {
  //     const windowHeight = window.innerHeight;
  //     // Make modal body smaller on smaller screens
  //     if (windowHeight < 768) {
  //       setModalHeight(300);
  //     } else if (windowHeight < 900) {
  //       setModalHeight(400);
  //     } else {
  //       setModalHeight(450);
  //     }
  //   };

  //   handleResize(); // Set initial size
  //   window.addEventListener('resize', handleResize);

  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  // const handleDocumentClick = (docFile, title) => {
  //   setActiveDocument(docFile);
  //   setDocumentTitle(title);
  //   setViewerError(false);
  //   setUseFallback(false);
  //   setShowModal(true);

  //   // Reset scroll position of document viewer when opening a new document
  //   setTimeout(() => {
  //     const container = window.document.querySelector('.document-viewer-container');
  //     if (container) {
  //       container.scrollTop = 0;
  //     }
  //   }, 100);
  // };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  //   setActiveDocument(null);
  //   setViewerError(false);
  //   setUseFallback(false);
  // };

  // const onError = (e) => {
  //   console.log('Error in file viewer:', e);
  //   setViewerError(true);
  // };

  // const tryFallbackViewer = () => {
  //   setUseFallback(true);
  //   setViewerError(false);
  // };

  // Only render Footer on /login or /signup routes
  if (location.pathname !== "/login" && location.pathname !== "/signup") {
    return null;
  }
  return (
    <>
      <footer
        className="p-2 text-white w-100"
        style={{ backgroundColor: 'transparent' }}
      >
        <div className="d-flex flex-column flex-md-row align-items-center align-items-md-end justify-content-center justify-content-md-end">

    {/* Copyright */}
    <p className="mb-0 text-center text-md-end" style={{ lineHeight: 1.2 }}>
      © {new Date().getFullYear()} Vesseli
    </p>

    {/* Links */}
    <p className="mb-0 mt-1 mt-md-0 text-center text-md-end ms-md-2">
      <Link
        to="/cookie-policy"
        className="text-yellow text-decoration-underline"
      >
        Cookie Policy
      </Link>
      &nbsp;|&nbsp;
      <Link
        to="/terms-and-conditions"
        className="text-yellow text-decoration-underline"
      >
        Terms & Conditions
      </Link>
      &nbsp;|&nbsp;
      <Link
        to="/privacy-policy"
        className="text-yellow text-decoration-underline"
      >
        Privacy Policy
      </Link>
      &nbsp;|&nbsp;
      <Link
        to="/child-protection-policy"
        className="text-yellow text-decoration-underline"
      >
        Child Policy
      </Link>
      &nbsp;|&nbsp;
      <Link
        to="/account-deletion-guide"
        className="text-yellow text-decoration-underline"
      >
        Account Deletion Guide
      </Link>
    </p>

  </div>
</footer>

      {/* Modal popup code commented out - now using dedicated pages instead
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
        dialogClassName="document-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{documentTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '10px', overflow: 'hidden' }}>
          {activeDocument && (
            <div className="document-viewer-container" style={{ height: `${modalHeight}px`, overflow: 'auto', marginBottom: '10px' }}>
              {viewerError ? (
                <Alert variant="warning">
                  <Alert.Heading>Unable to preview document</Alert.Heading>
                  <p>
                    We're having trouble displaying this document in the browser.
                    You can try our alternative viewer or download the document.
                  </p>
                  <div className="d-flex justify-content-end">
                    <Button variant="outline-primary" onClick={tryFallbackViewer}>
                      Try Alternative Viewer
                    </Button>
                  </div>
                </Alert>
              ) : useFallback ? (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(window.location.origin + activeDocument)}&embedded=true`}
                  style={{ width: '100%', height: '100%', border: 'none' }}
                  title={documentTitle}
                  frameBorder="0"
                />
              ) : (
                <React.Suspense fallback={<div className="text-center p-4">Loading document...</div>}>
                  <LazyFileViewer
                    fileType="docx"
                    filePath={activeDocument}
                    onError={onError}
                  />
                </React.Suspense>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {activeDocument && (
            <Button variant="primary" href={activeDocument} download>
              Download
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      */}
    </>
  );
};

export default Footer;
